import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, RadioIcon, XIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <div className="relative z-50 bg-green-800 text-white" data-id="element-474" data-mp="1j3xz2cen6ljr">
      <div className="mx-auto flex max-w-content items-center gap-3 px-4 py-2.5 sm:px-6 lg:px-10" data-id="element-475" data-mp="1o2iqbmbx1uw2">
        <span className="flex items-center gap-1.5 rounded bg-gold-500 px-2 py-0.5 text-[11px] font-bold uppercase tracking-[0.1em] text-ink" data-id="element-476" data-mp="rcrw7o7je9qs">
          <RadioIcon aria-hidden className="h-3 w-3" data-id="element-477" data-mp="vfo6mrmxazjn" />
          Live Saturday
        </span>
        <p className="flex-1 truncate text-[13px] text-white/85 sm:text-sm" data-id="element-478" data-mp="10bdb99dsv6mt">
          Presidential Town Hall on Jobs &amp; Enterprise — Abuja, 6:00 PM WAT
        </p>
        <Link to="/live" className="hidden shrink-0 items-center gap-1.5 text-[13px] font-semibold text-gold-300 transition-colors duration-150 ease-emphasis hover:text-gold-100 sm:inline-flex" data-id="element-479" data-mp="2bqs6o8qd1qft">
          Register
          <ArrowRightIcon aria-hidden className="h-3.5 w-3.5" data-id="element-480" data-mp="1091preq16bj9" />
        </Link>
        <button type="button" onClick={() => setVisible(false)} aria-label="Dismiss announcement" className="shrink-0 rounded p-1 text-white/60 transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-481" data-mp="wa2elcdphijd">
          <XIcon aria-hidden className="h-4 w-4" data-id="element-482" data-mp="hctmgggkwaql" />
        </button>
      </div>
    </div>;
}